let _capacitor = null;
try {
  // eslint-disable-next-line
  _capacitor = require('@capacitor/core').Capacitor;
} catch {
  // Capacitor not available
}

export const isNative = () => {
  try { return _capacitor?.isNativePlatform() ?? false; } catch { return false; }
};
export const isIOS = () => {
  try { return _capacitor?.getPlatform() === 'ios'; } catch { return false; }
};
export const isAndroid = () => {
  try { return _capacitor?.getPlatform() === 'android'; } catch { return false; }
};
export const isWeb = () => {
  try { return _capacitor?.getPlatform() === 'web' || !_capacitor; } catch { return true; }
};
